import CreateColumn from '../../../../Services/agGrid/createColumn';
import dayjs from 'dayjs';

const STATUS_LABEL = {
  DRAFT: '작성중',
  SAVED: '임시저장',
  CONFIRMED: '확정',
};

/**
 * @param {object} props - 컴포넌트 props
 * @returns {Array} 컬럼 정의 배열
 */
export const getColumnDefs1 = (props) => {
  return [
    CreateColumn('no', 'NO', 'center', 80, false, false, false, 'checkbox', {
      flex: 1,
      minWidth: 80,
      checkboxProps: {
        DeleteNewRow1: props.DeleteNewRow1,
        RestoreRow1: props.RestoreRow1,
        gridRef1: props.gridRef1,
        rowData1: props.rowData1,
        selectedRowNosRef: props.selectedRowNosRef,
        lastCheckedIndexRef: props.lastCheckedIndexRef,
        handleRowSelection: props.handleRowSelection,
      },
    }),

    CreateColumn(
      'evaDate',
      '평가일자',
      'center',
      120,
      false,
      false,
      false,
      'text',
      {
        flex: 1,
        minWidth: 100,
        valueFormatter: (params) => {
          const v = params?.value;
          if (!v) return '';
          return String(v).substr(0, 10);
        },
      }
    ),

    CreateColumn(
      'evaName',
      '평가자',
      'center',
      120,
      false,
      false,
      false,
      'text',
      { flex: 1, minWidth: 100 }
    ),

    CreateColumn(
      'versionNm',
      '평가표',
      'left',
      120,
      false,
      false,
      false,
      'text',
      {
        flex: 1,
        minWidth: 100,
        valueFormatter: (params) => params.data?.versionNm || '',
      }
    ),

    CreateColumn(
      'obtainedScore',
      '취득점수',
      'right',
      140,
      false,
      false,
      false,
      'text',
      {
        flex: 1,
        minWidth: 120,
        valueFormatter: (params) => {
          const data = params.data || {};
          const obtained = Math.round(
            Number(
              data.obtainedScore ??
                data.ObtainedScore ??
                data.evaPoint ??
                data.EvaPoint ??
                0
            )
          );
          const total = Math.round(
            Number(data.totalScore ?? data.TotalScore ?? 0)
          );
          if (!obtained && !total) return '';
          if (!total) return String(obtained);
          return `${obtained}/${total}`;
        },
      }
    ),

    CreateColumn(
      'evaStatus',
      '평가상태',
      'center',
      100,
      false,
      false,
      false,
      'text',
      {
        flex: 1,
        minWidth: 90,
        valueFormatter: (params) => {
          const key = String(params?.value ?? '').toUpperCase();
          return STATUS_LABEL[key] || params?.value || '';
        },
      }
    ),

    CreateColumn(
      'sdCode',
      '평가코드',
      'center',
      140,
      false,
      false,
      true,
      'text',
      { flex: 1, minWidth: 100 }
    ),
  ];
};

const columnDefs = { getColumnDefs1 };
export default columnDefs;
